import { create } from "zustand";
import { 
  fetchBrandAwareness, 
  fetchBrandAwarenessOverview, 
  fetchBrandAwarenessDetailByIndustry 
} from "./brandAwarenessApi";
import { notifications } from "@mantine/notifications";
import { produce } from "immer";
import i18n from "../../i18n";

export const useBrandAwarenessStore = create((set, get) => ({
  awarenessMeasurements: null,
  overviewData: null,
  industryDetails: {},
  isLoading: true,

  getMeasurementsByBrandId: async (brandId) => {
    const existingMeasurements = get().awarenessMeasurements?.filter(
      (m) => m.brandId === brandId
    );
    if (existingMeasurements?.length > 0) {
      console.log("Measurements found in store:", existingMeasurements);
      return existingMeasurements;
    }
    console.log("Measurements not found in store, fetching:", brandId);
    // If measurements are not in the store, fetch them:
    set({ isLoading: true });
    try {
      const measurements = await fetchBrandAwareness(brandId);
      set({
        awarenessMeasurements: [
          ...get().awarenessMeasurements ?? [],
          ...measurements,
        ],
        isLoading: false,
      });
    } catch (err) {
      console.error("Error fetching brand awareness:", err);
      notifications.show({
        title: i18n.t(
          "brands.notifications.fetch_failed",
          "Failed to fetch brand awareness"
        ),
        color: "red",
      });
    }
  },

  getOverviewByBrandId: async (brandId) => {
    const existingOverview = get().overviewData?.[brandId];
    if (existingOverview) {
      console.log("Overview found in store:", existingOverview);
      return existingOverview;
    }
    
    console.log("Overview not found in store, fetching:", brandId);
    set({ isLoading: true });
    try {
      const overview = await fetchBrandAwarenessOverview(brandId);
      set(produce((state) => {
        if (!state.overviewData) state.overviewData = {};
        state.overviewData[brandId] = overview;
        state.isLoading = false;
      }));
      return overview;
    } catch (err) {
      console.error("Error fetching brand awareness overview:", err);
      notifications.show({
        title: i18n.t(
          "brands.notifications.fetch_failed",
          "Failed to fetch brand awareness overview"
        ),
        color: "red",
      });
      set({ isLoading: false });
    }
  },

  getIndustryDetailsByBrandId: async (brandId, industry) => {
    const existingDetails = get().industryDetails?.[`${brandId}_${industry}`];
    if (existingDetails) {
      console.log("Industry details found in store:", existingDetails);
      return existingDetails;
    }
    
    console.log("Industry details not found in store, fetching:", brandId, industry);
    try {
      const details = await fetchBrandAwarenessDetailByIndustry(brandId, industry);
      set(produce((state) => {
        if (!state.industryDetails) state.industryDetails = {};
        state.industryDetails[`${brandId}_${industry}`] = details;
      }));
      return details;
    } catch (err) {
      console.error("Error fetching industry details:", err);
      notifications.show({
        title: i18n.t(
          "brands.notifications.fetch_failed",
          "Failed to fetch industry details"
        ),
        color: "red",
      });
    }
  },
}));
